import { render, staticRenderFns } from "./mainBanner.vue?vue&type=template&id=5b6a0b15"
import script from "./mainBanner.vue?vue&type=script&lang=js"
export * from "./mainBanner.vue?vue&type=script&lang=js"
import style0 from "./mainBanner.vue?vue&type=style&index=0&id=5b6a0b15&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports